import React from 'react';
import { entitlementsPiletModals } from '@sharefiledev/entitlements-pilet-sdk';
import { OverlayModalComponentProps } from '@sharefiledev/sharefile-appshell';
export type Props = Pick<
	OverlayModalComponentProps<typeof entitlementsPiletModals.entitlementsModal>,
	'cancelInteraction'
>;

export const EmptyModal: React.FC<Props> = ({ cancelInteraction }) => {
	React.useEffect(() => {
		cancelInteraction();
	}, [cancelInteraction]);

	return null;
};
